import mobileAppComponent from './mobile_app.component';
import mobileAppAll from './all';
import mobileAppCreate from './create'

let mobileAppModule = angular.module('mobileApp', [
    mobileAppAll,
    mobileAppCreate
])

    .component('mobileApp', mobileAppComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('mobile_app.all', {
                url: '/all/:page',
                component: 'mobileAppAll',
                data: {
                    requireACL: 'tnt_control_mobile_app.view'
                }
            })
            .state('mobile_app.create', {
                url:'/create',
                component: 'mobileAppCreate',
                data: {
                    requireACL: 'tnt_control_mobile_app.create'
                }
            })
    })

    .name;

export default mobileAppModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/index.js